import axios from "axios";
import { useState } from "react";
import { Plus } from "lucide-react";
import TransactionFields from "./TransactionFields";
import { buildPayload, emptyForm, useDateRate, validate } from "../lib/transactionForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TransactionForm({ groups, accounts, onCreated }) {
  const [form, setForm] = useState(emptyForm);
  const [notice, setNotice] = useState("");
  const dateRate = useDateRate(form.transaction_date);

  const setField = (key, value) => setForm(current => ({ ...current, [key]: value }));
  const incomeMode = form.kind === "income";

  const submit = async event => {
    event.preventDefault();
    const error = validate(form);
    if (error) { setNotice(error); return; }
    try {
      await axios.post(`${API}/transactions`, buildPayload(form, dateRate.rate, dateRate.rates));
      setForm(current => ({ ...emptyForm(), transaction_date: current.transaction_date, kind: current.kind, group: current.group, account: current.account, commission_mode: current.commission_mode }));
      setNotice(form.recurring && form.kind === "expense" ? "Kayıt eklendi · aylık tekrar tanımlandı" : "Kayıt eklendi");
      onCreated?.();
    } catch {
      setNotice("Kayıt eklenemedi");
    }
  };

  return (
    <section className="panel add-panel">
      <div className="panel-head">
        <div>
          <p className="eyebrow">YENİ HAREKET</p>
          <h3>{incomeMode ? "Cirodan gelir hesapla" : "Hızlı gider kaydı"}</h3>
        </div>
        <Plus size={20}/>
      </div>
      <form onSubmit={submit}>
        <TransactionFields form={form} setField={setField} groups={groups} accounts={accounts} dateRate={dateRate} allowRecurring/>
        <button className="primary-btn" data-testid="add-transaction-button" type="submit">Kaydı ekle <Plus size={17}/></button>
        {notice && <div className="notice" data-testid="form-notice">{notice}</div>}
      </form>
    </section>
  );
}
